import { builderDispatch, ShelfUI } from '../_utils/ui';
import Events from './flux-events';

let searchSerialNumber = 0;

(function () {
  if (typeof s_omni !== 'object') return;

  const old_omni = {};

  const omni = {
    adid: s_omni.getQueryParam('adid'),
    fbref: s_omni.getQueryParam('fb_ref'),
    sourceid: s_omni.getQueryParam('sourceid'),
    povid: s_omni.getQueryParam('povid'),
    findingMethod: s_omni.getQueryParam('findingMethod'),
    getCampaignId() {
      if (this.adid) { return this.adid; }
      if (this.fbref) { return this.fbref.split('_')[1]; }
      if (this.sourceid) { return this.sourceid; } return '';
    },
  }; s_omni.campaign = omni.getCampaignId(); s_omni.channel = window.location.hostname;
  // Create IE + others compatible event handler
  const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
  const eventer = window[eventMethod];
  const messageEvent = (eventMethod === 'attachEvent') ? 'onmessage' : 'message';

  function getEventName(event, eventType) {
    if (ShelfUI && eventType && eventType.hasOwnProperty(event)) {
      return eventType[event];
    }
    return 'Unknown';
  }

  // Click Event Listeners
  const clickDispatchToken = builderDispatch.register((payload) => {
    try {
      switch (payload.type) {
        // Left Hand Nav Selection Cases
        case Events.OMNI_FILTER_SELECTED:
          omniLinkClick('o', getEventName(payload.type, ShelfUI.EventStrings), payload.filter, payload.option, payload.succeeded);
          break;
        case Events.OMNI_FILTER_CLEARED:
          omniLinkClick('o', getEventName(payload.type, ShelfUI.EventStrings), `Filter ${payload.filter} Cleared`, '');
          break;
        case Events.SEARCH_CLEARED:
          omniLinkClick('o', getEventName(payload.type, ShelfUI.EventStrings), 'Clear Search', payload.option);
          break;
        case Events.SEARCH_SELECTED:
          ++searchSerialNumber;
          omniLinkClick('o', getEventName(payload.type, ShelfUI.EventStrings), 'Search Text:', payload.option, payload.succeeded);
          break;
      }
    } catch (e) {
      window.console && window.console.warn && window.console.warn(e);
    }
  });

  // Omni Dispatcher
  function omniLinkClick(linkType, omniLinkName, filter, option, searchSucceeded) {
    const s_linkTrackVarsTemp = s_omni.linkTrackVars;
    const s_linkTrackEventsTemp = s_omni.linkTrackEvents;

    s_omni.trackExternalLinks = false;
    s_omni.linkTrackVars = 'prop54';
    s_omni.linkTrackEvents = 'None';
    s_omni.prop1 = 'Shelf';
    s_omni.prop2 = `${s_omni.prop1} ${s_omni.pageName}, Selected Filter: ${filter} ${option}`;
    s_omni.events = 'event37';
    s_omni.eVar2 = undefined;
    s_omni.prop14 = undefined;

    if (filter.indexOf('Search') > -1 && filter.indexOf('Clear Search') < 0) {
      s_omni.prop1 = 'Search Shelf';
      delete s_omni.prop3;
      delete s_omni.prop4;
      delete s_omni.prop5;
      s_omni.events = searchSucceeded ? `event108, event109:${searchSerialNumber}` : `event108, event109:${searchSerialNumber}, event110`;
      s_omni.eVar2 = option;
      s_omni.prop14 = option;
    }
    s_omni.t(s_omni, linkType, 'Filter Select');

    // Reset
    s_omni.linkTrackVars = s_linkTrackVarsTemp;
    s_omni.linkTrackEvents = s_linkTrackEventsTemp;
  }

  // Clean Up
  window.addEventListener('unload', () => {
    builderDispatch.unregister(clickDispatchToken); // Clean up on exit
  });
}());
